import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Box } from '@redriverpress/system'

import Divider from './Divider'
import StepCircle from './StepCircle'

const stepVariants = {
  default: {
    display: ['none', null, 'inline-flex'],
  },
  done: {
    display: ['none', null, 'inline-flex'],
  },
}

export default function Stepper({ steps, active }) {
  const activeIdx = steps.findIndex(step => step.id === active)

  return (
    <Box display='inline-flex'>
      {steps.map((step, idx) => {
        let variant = 'default'
        if (activeIdx >= idx) {
          variant = activeIdx > idx ? 'done' : 'active'
        }

        return (
          <Fragment key={step.id}>
            <Box
              fontSize={0}
              display='inline-flex'
              flexDirection='column'
              alignItems='center'
              {...stepVariants[variant]}
            >
              <StepCircle label={idx + 1} variant={variant} />
              <Box>{step.label}</Box>
            </Box>
            {idx < steps.length - 1 && <Divider px={1} variant={variant} />}
          </Fragment>
        )
      })}
    </Box>
  )
}

export const stepIdProp = PropTypes.string

const stepPropShape = {
  id: stepIdProp.isRequired,
  label: PropTypes.string.isRequired,
  url: PropTypes.string,
}

Stepper.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape(stepPropShape)).isRequired,
  active: stepIdProp.isRequired,
}
